import React, { createContext, useState, useContext, useEffect } from "react";

const SidebarContext = createContext({
  isSidebarOpen: true,
  setIsSidebarOpen: () => {},
  isCollapsibleMode: false,
});

export const SidebarProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true); // Open by default
  const [isCollapsibleMode, setIsCollapsibleMode] = useState(false);

  useEffect(function setupResizeListener() {
    const checkCollapsibleMode = () => {
      const width = window.innerWidth;
      // Collapsible mode for widths between 600px and 1099px
      setIsCollapsibleMode(width >= 600 && width < 1100);
    };

    checkCollapsibleMode();
    window.addEventListener("resize", checkCollapsibleMode);

    return () => window.removeEventListener("resize", checkCollapsibleMode);
  }, []);

  const value = {
    isSidebarOpen,
    setIsSidebarOpen,
    isCollapsibleMode,
  };

  return (
    <SidebarContext.Provider value={value}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within SidebarProvider");
  }
  return context;
};

export default SidebarContext;

